import appApiEndPoints from "../constant/appApiEndPoints";

const recaptchaRepository = {
  /**
   * Verify a recaptcha token with the backend.
   *
   * Expected backend response shape:
   * {
   *   "success": false,
   *   "statusCode": 400,
   *   "message": "...",
   *   "data": {
   *     "success": true,
   *     "challenge_ts": "...",
   *     "hostname": "...",
   *     "score": 0.7,
   *     "action": "payment_page_load",
   *     "v2Required": true
   *   },
   *   "errors": null
   * }
   */
  async verify({ version, token, action }) {
    const response = await fetch(appApiEndPoints.recaptchaVerify, {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ version, token, action }),
    });

    let data = null;
    try {
      data = await response.json();
    } catch (e) {
      data = null;
    }

    // eslint-disable-next-line no-console
    console.log("[Recaptcha verify]", version, data);
    return data;
  },
};

export default recaptchaRepository;
